import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Book, Heart, MessageCircle, Brain, Shield, Link, AlertCircle, List, Clock } from 'lucide-react';
export function StackSection() {
  const tomos = [{
    title: 'El Mapa del Alma de tu Hijo',
    number: 'TOMO 1',
    desc: 'Conocé la personalidad profunda de tu hijo: cómo piensa, cómo siente, qué lo mueve y qué necesita para florecer. Esta es la base de todo el sistema.',
    icon: <Heart className="w-6 h-6 text-dusty-rose-500" data-id="element-204" />
  }, {
    title: 'Su Forma de Aprender',
    number: 'TOMO 2',
    desc: 'Descubrí cómo aprende mejor tu hijo y transformá la hora de la tarea y los límites en momentos de conexión en lugar de batalla.',
    icon: <Brain className="w-6 h-6 text-dusty-rose-500" data-id="element-205" />
  }, {
    title: 'Sus Emociones y Cómo Acompañarlas',
    number: 'TOMO 3',
    desc: 'Entendé por qué reacciona como reacciona — y aprendé a acompañar sus emociones sin perder la calma ni sentirte culpable después.',
    icon: <Shield className="w-6 h-6 text-dusty-rose-500" data-id="element-206" />
  }, {
    title: 'Su Forma de Comunicarse',
    number: 'TOMO 4',
    desc: 'Aprendé a hablarle en su propio lenguaje para que te escuche, te entienda y responda de verdad.',
    icon: <MessageCircle className="w-6 h-6 text-dusty-rose-500" data-id="element-207" />
  }, {
    title: 'Crianza Sin Conflicto',
    number: 'TOMO 5',
    desc: 'Estrategias concretas y aplicables para reducir las peleas, las crisis y el agotamiento en tu vida cotidiana.',
    icon: <Book className="w-6 h-6 text-dusty-rose-500" data-id="element-208" />
  }, {
    title: 'Conexión Profunda',
    number: 'TOMO 6',
    desc: 'Construí el vínculo con tu hijo que lo acompañe y lo sostenga durante toda su vida.',
    icon: <Link className="w-6 h-6 text-dusty-rose-500" data-id="element-209" />
  }];
  const bonuses = [{
    title: 'Guía de Emergencia',
    number: 'BONUS 1',
    desc: 'Para usar en el momento exacto en que tu hijo explota, se cierra o no te escucha. Respuestas paso a paso. Inmediatas. Sin teoría.',
    icon: <AlertCircle className="w-6 h-6 text-gold-500" data-id="element-210" />
  }, {
    title: 'Diccionario de Conductas',
    number: 'BONUS 2',
    desc: 'Las 30 conductas más desafiantes de los niños explicadas con claridad y con una respuesta concreta y amorosa para cada una.',
    icon: <List className="w-6 h-6 text-gold-500" data-id="element-211" />
  }, {
    title: 'Rituales de Conexión',
    number: 'BONUS 3',
    desc: 'Rutinas simples de 5 minutos diarios para crear momentos reales de vínculo con tu hijo sin importar lo ocupada que estés.',
    icon: <Clock className="w-6 h-6 text-gold-500" data-id="element-212" />
  }];
  return <section className="py-8 md:py-10 px-4 bg-cream-50" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <FadeIn data-id="element-215">
          <h2 className="text-2xl md:text-5xl font-bold text-center text-burgundy-900 mb-8 md:mb-16" data-id="element-216">
            Todo lo que recibís cuando te sumás hoy
          </h2>
        </FadeIn>

        {/* Tomos Section */}
        <div className="mb-10 md:mb-20" data-id="element-217">
          <FadeIn data-id="element-218">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-burgundy-800 mb-5 md:mb-8 flex items-center justify-center gap-3" data-id="element-219">
              <span className="text-2xl md:text-3xl" data-id="element-220">📚</span> LOS 6 TOMOS DE LA
              COLECCIÓN
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-221">
            {tomos.map((tomo, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-222">
                <div className="bg-white rounded-2xl p-4 md:p-6 shadow-sm border border-cream-100 border-l-4 border-l-dusty-rose-300 h-full flex flex-col hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-223">
                  <div className="absolute top-0 right-0 w-24 h-24 bg-dusty-rose-50 rounded-bl-full -z-10" data-id="element-224"></div>
                  <div className="flex items-center gap-3 mb-3 md:mb-4" data-id="element-225">
                    <div className="p-2 bg-dusty-rose-100 rounded-lg" data-id="element-226">
                      {tomo.icon}
                    </div>
                    <div data-id="element-227">
                      <p className="text-xs font-bold text-dusty-rose-500 tracking-wider" data-id="element-228">
                        {tomo.number}
                      </p>
                      <h4 className="font-heading font-bold text-base md:text-lg text-burgundy-900 leading-tight" data-id="element-229">
                        {tomo.title}
                      </h4>
                    </div>
                  </div>
                  <p className="text-burgundy-700 text-sm leading-relaxed flex-grow" data-id="element-230">
                    {tomo.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        {/* Bonuses Section */}
        <div data-id="element-231">
          <FadeIn data-id="element-232">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-burgundy-800 mb-5 md:mb-8 flex items-center justify-center gap-3" data-id="element-233">
              <span className="text-2xl md:text-3xl" data-id="element-234">🎁</span> LOS 3 BONUS
              EXCLUSIVOS
            </h3>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-235">
            {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-236">
                <div className="bg-gradient-to-b from-gold-100 to-white rounded-2xl p-4 md:p-6 shadow-sm border border-gold-200 h-full flex flex-col hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-237">
                  <div className="absolute -right-4 -top-4 w-20 h-20 bg-gold-200 rounded-full blur-xl opacity-50" data-id="element-238"></div>
                  <div className="flex items-center gap-3 mb-3 md:mb-4 relative z-10" data-id="element-239">
                    <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-240">
                      {bonus.icon}
                    </div>
                    <div data-id="element-241">
                      <p className="text-xs font-bold text-gold-600 tracking-wider" data-id="element-242">
                        {bonus.number}
                      </p>
                      <h4 className="font-heading font-bold text-base md:text-lg text-burgundy-900 leading-tight" data-id="element-243">
                        {bonus.title}
                      </h4>
                    </div>
                  </div>
                  <p className="text-burgundy-700 text-sm leading-relaxed flex-grow relative z-10" data-id="element-244">
                    {bonus.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}